export default {
  inventories: [],
  inventory: null,
  loading: false,
  total: 0,
  FilteredCount: 0,
  ingredients: [],
  'inventory-histories': [],
  'inventory-loading': false,
  'inventory-total': 0,
  'inventory-FilteredCount': 0
}
